<script lang="ts" setup>
import faqModelJSON from '~/../assets/faq_models/processes.json';
import FAQIndex from '~/components/FAQ/FAQIndex.vue';
const content = faqModelJSON as unknown as FAQMenuContent[];
</script>
<template>
  <FAQIndex :content="content" type="processes" router-articles="ProcessesArticles" />
</template>
